
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function Business() {
  const sectionAnimation = useScrollAnimation();

  const handleNavigate = () => {
    window.REACT_APP_NAVIGATE('/business');
  };

  return (
    <section id="business" className="py-12 sm:py-16 bg-sky-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div 
          ref={sectionAnimation.ref as React.RefObject<HTMLDivElement>}
          className={`grid md:grid-cols-2 gap-12 sm:gap-16 md:gap-20 items-center scroll-animate ${sectionAnimation.isVisible ? 'is-visible' : ''}`}
        >
          <div className="w-full h-[250px] sm:h-[350px] md:h-[400px] relative group order-2 md:order-1">
            <div className="absolute inset-0 bg-gradient-to-br from-sky-200 to-blue-400 rounded-lg transform -rotate-3 group-hover:-rotate-6 transition-transform duration-300"></div>
            <div className="relative h-full border-4 border-white rounded-lg overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/0947c5c75234eb0df91750a621813a72/de81cd3d120ced2b574d4061ce2d32b9.jpeg"
                alt="事業内容"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="space-y-5 sm:space-y-7 order-1 md:order-2">
            <div>
              <div className="w-20 sm:w-24 h-0.5 bg-blue-600 mb-3 sm:mb-4"></div>
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900">
                事業内容
              </h2>
            </div>
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
              当社は、電気設備工事を中心に、空調・消防設備工事など、建物に関わる各種設備工事を行っています。
            </p>
            <div className="flex justify-end mr-0 md:mr-12">
              <button
                onClick={handleNavigate}
                className="group inline-flex items-center gap-2 sm:gap-3 px-6 sm:px-8 py-2.5 sm:py-3 border-2 border-blue-600 text-blue-600 rounded-full hover:bg-blue-600 hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap text-sm sm:text-base"
              >
                <span className="font-semibold">詳しくはこちら</span>
                <i className="ri-arrow-right-line text-lg sm:text-xl group-hover:translate-x-1 transition-transform duration-300"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
